import { createSelector } from "reselect";

import { RootState } from "../../store/types";
import { AuthState } from "./reducer";

export const auth = (state: RootState): AuthState => state.auth;

// Raw state
export const token = createSelector(auth, state => state.token);
export const tokenPayload = createSelector(auth, state => state.tokenPayload);
export const customer = createSelector(auth, state => state.customer);
export const tokenRefreshing = createSelector(
  auth,
  state => state.tokenRefreshing,
);

// Derived state
export const isLoggedIn = createSelector(token, token => token != null);



// WEBPACK FOOTER //
// ./src/routes/Auth/selectors.ts